module.exports = __webpack_public_path__ + "fonts/ClearSans-Thin-webfontdea29776348b921a63e12ab9560e2dcc.svg";